import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpGptDescribe {
}
ApiSmpGptDescribe.retrieve = (params, signal) => apiRequest({
    body: params,
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/describe",
    method: "POST",
    signal,
});
//# sourceMappingURL=describe.js.map